import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { NewsListComponent } from './news-list/news-list.component';

import { ResearchComponent } from './research/research.component';
import { ContactComponent } from './contact/contact.component';
import {PeopleComponent} from './people/people.component';
import {PublicationsComponent} from './publications/publications.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'news', component: NewsListComponent },
  { path: 'people', component: PeopleComponent },
  { path: 'research', component: ResearchComponent },
  { path: 'publications', component: PublicationsComponent },
  { path: 'contact', component: ContactComponent },

  { path: '', redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
